import React from "react";
import flowers from "../data/bucheteDeToamna";
import FlowerContainer from "../components/FlowerContainer";

const BucheteDeToamna = () => {
  return (
    <FlowerContainer
      flowers={flowers}
      title="Buchete De Toamna"
      subtitle="Buchete în nuanțe calde, inspirate de frumusețea sezonului tomnatic."
      storageKey="BUCHETE_DE_TOAMNA_SCROLL_POSITION"
    />
  );
};

export default BucheteDeToamna;
